import { css } from "@emotion/react";

import { dimensions } from "@styles";

export const icon = {
  base: css`
    border-radius: ${dimensions.circleRadius};
  `,
  Gold: css`
    background-color: #dca270; //TODO add token
  `,
  Silver: css`
    background-color: #949494; //TODO add token
  `,
  large: css`
    width: 36px;
    height: 36px;
    padding: 0.375rem;
  `,
  small: css`
    width: 24px;
    height: 24px;
  `,
  xsmall: css`
    width: 16px;
    height: 16px;
  `,
};
